import React from 'react'
import { Col, DatePicker, Form, Input, Row } from 'antd'
import { get } from 'lodash'
import TextArea from 'antd/lib/input/TextArea'
import { defaultFormItemLayout, rules } from '../../../../modules/FormItems'
import { dateVal, normalizeNull } from '../../../../modules/Utils'
import {
  BUDGET_TYPE_INTERNAL,
  BUDGET_TYPE_SALES,
} from '../../../../components/Common/Budgets/BudgetCont'
import AccountsCascader from '../../../../elements/Cascader/AccountsCascader'

const { MonthPicker } = DatePicker

function BookingForm(props) {
  const { getFieldDecorator, getFieldValue, setFieldsValue } = props.form
  const { object: budgetLine, option, budget } = props

  function changeName(date) {
    if (date) {
      const name = budget.account.name + ' ' + date.format('YYYY MMM')
      setFieldsValue({ name })
    }
  }

  return (
    <Row>
      <Form layout={'horizontal'}>
        {option === BUDGET_TYPE_INTERNAL && (
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label={'Period'}>
              {getFieldDecorator('periodDisplay', {
                initialValue: dateVal(budgetLine, 'periodDisplay'),
              })(
                <MonthPicker onChange={changeName} format={'YYYY MMM'} style={{ width: '100%' }} />
              )}
            </Form.Item>
          </Col>
        )}
        {option === BUDGET_TYPE_SALES && (
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label={'Account'}>
              {getFieldDecorator('accounts', {
                initialValue: get(budgetLine, 'accounts'),
                rules: rules.input,
              })(
                <AccountsCascader
                  center={get(budget, 'center._id')}
                  placeholder={'Account'}
                  codeMin={5000}
                />
              )}
            </Form.Item>
          </Col>
        )}
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label={'Target'}>
            {getFieldDecorator('target', {
              initialValue: get(budgetLine, 'target'),
              rules: rules.input,
            })(
              <Input
                type="number"
                addonBefore={<strong>{budget.currency}</strong>}
                style={{ width: '100%' }}
                placeholder={'Amount'}
              />
            )}
          </Form.Item>
        </Col>
        {option === BUDGET_TYPE_INTERNAL && (
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label={'Name'}>
              {getFieldDecorator('name', {
                initialValue: get(budgetLine, 'name'),
                normalize: normalizeNull,
              })(<Input placeholder={'Name'} />)}
            </Form.Item>
          </Col>
        )}
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label={'Notes'}>
            {getFieldDecorator('notes', {
              initialValue: get(budgetLine, 'notes'),
              normalize: normalizeNull,
            })(<TextArea placeholder={'Notes'} />)}
          </Form.Item>
        </Col>
      </Form>
    </Row>
  )
}

BookingForm.propTypes = {}
BookingForm.defaultProps = { booking: {}, type: 'new' }

export default Form.create()(BookingForm)
